import Scaffold from "../commons/scaffold/scaffold";

import "./completion_order.css";
import ViewController from "../commons/base/view_controller";
import CompletionViewModel, {
    CompletionState,
} from "./view_models/completion_view_model";
import CompletionTable from "./widgets/completion_table";

export default class CompletionOrderScreen extends ViewController<
    {},
    CompletionState,
    CompletionViewModel
> {
    constructor(props: {}) {
        super(props, new CompletionViewModel());
    }

    render() {
        return (
            <Scaffold isShowLoading={this.vmState.isLoading}>
                {this.vmState.errorMessage.length > 0 && (
                    <h1 className="text-red-600 mt-12">
                        {this.vmState.errorMessage}
                    </h1>
                )}
                <div className="grid grid-cols-4 grid-flow-col-dense">
                    {/* Shack */}
                    <CompletionTable
                        tableName="SHACK"
                        completionData={this.vmState.shackFirstHalfData}
                    />
                    <CompletionTable
                        tableName="SHACK"
                        completionData={this.vmState.shackSecondHalfData}
                    />
                    {/* Shack Special */}
                    <CompletionTable
                        tableName="SHACK SPECIAL"
                        completionData={this.vmState.shackSpecialData}
                    />
                    {/* Ruko */}
                    <CompletionTable
                        tableName="RUKO"
                        completionData={this.vmState.rukoData}
                    />
                </div>
            </Scaffold>
        );
    }
}
